<template>
  <tr
    :style="$vuetify.breakpoint.mdAndUp ? 'cursor:pointer' : ''"
    @click="
      $vuetify.breakpoint.mdAndUp &&
        $router.push({
          name: $route.meta.requestType === 'admin' ? 'documentsAllShow' : 'documentsPersonalShow',
          params: { id: item.id },
        })
    "
  >
    <td>
      <div class="name">
        <img :src="require('~/assets/img/setting/freeDocument/' + item.icon)" alt="icon" />
        {{ item.name }}
      </div>
    </td>
    <td v-if="this.$route.meta.requestType === 'admin'">
      <div class="users">
        <router-link
          v-for="(user, key) in item.users"
          :key="key"
          :to="{
            name: 'PersonalAreaEmployee',
            params: { userId: user.id },
          }"
          class="userChip f12"
        >
          {{ user.first_name + ' ' + user.last_name }}
        </router-link>
        <div class="userChip f12" style="background: #26bc2c" v-if="!item.users.length">
          {{ localStorage.translations.pages.common.text.to_all }}
        </div>
      </div>
    </td>
    <td
      v-if="
        $userCheckAccess({
          abilities: 'edit_free_documents',
        })
      "
    >
      <div class="buttons">
        <ButtonShow
          v-if="$vuetify.breakpoint.smAndDown"
          :to-name="$route.meta.requestType === 'admin' ? 'documentsAllShow' : 'documentsPersonalShow'"
          :to-params="item.id"
        />
        <DocumentsGroupModal
          v-if="true"
          :group="item"
          :functionDownloadPageData="functionDownloadPageData"
        />
        <DeleteModal
          v-if="
            $userCheckAccess({
              abilities: ['view_users', 'edit_free_documents'],
            })
          "
          ref="deleteModal"
          :text="
            localStorage.translations.pages['setting-free_documents']['dialogs_titles'][
              'delete_group'
            ] +
            ' ' +
            item.name
          "
          :methodDelete="onDeleteDocumentsGroup"
        />
      </div>
    </td>
  </tr>
</template>

<script>
import DocumentsGroupModal from 'components/documents/DocumentsGroupModal'
import DeleteModal from 'components/DeleteModal'
import { mapActions } from 'vuex'
import ButtonShow from 'components/ButtonShow'

export default {
  name: 'DocumentsGroupTableItem',
  components: { ButtonShow, DocumentsGroupModal, DeleteModal },
  props: { item: Object, functionDownloadPageData: Function },
  data: () => ({}),
  methods: {
    ...mapActions('freeDocumentsGroups', [
      'onFreeDocumentsGroupsDelete',
      'onFreeDocumentsGroupsGrid',
    ]),
    onDeleteDocumentsGroup() {
      this.onFreeDocumentsGroupsDelete(this.item.id)
        .then((response) => {
          console.log(response)
          this.$store.dispatch(
            'popup/onMessage',
            {
              message:
                this.localStorage.translations.pages.common.notifications['uspeshno-udaleno'],
              IsError: false,
            },

            { root: true },
          )
          this.functionDownloadPageData()
        })
        .catch((err) => {
          this.$store.dispatch(
            'popup/onMessage',
            {
              message: this.localStorage.translations.pages.common.notifications['oshibka'],
              IsError: true,
            },
            { root: true },
          )
        })
    },
  },
}
</script>

<style lang="scss" scoped>
td {
  .name {
    display: grid;
    align-items: center;
    grid-template-columns: max-content auto;
    gap: 14px;
  }

  .users {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    align-items: center;
  }

  &:nth-child(1) {
    width: 25%;
  }

  &:nth-child(2) {
    width: auto;
  }
}
</style>
